
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import ICurrency from "@/module/main/dto/ICurrency";
import IBlock2Income from "@/module/main/model/applicationForm/IBlock2Income";
import IncomeType from "@/module/main/dto/customer/IncomeTypeEnum";
import { EnumUtil } from "@/app";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";

@Component
export default class Block2Income extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock2Income;
    @Prop({type: Object}) public currency!: ICurrency;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "block2-income";

    private incomeTypeChanged() {
        this.$emit("incomeTypeChanged", this.value.type);
    }

    private get incomeTypeData(): object[] {
        return EnumUtil.createSelectDataFromEnum(IncomeType, "IncomeType", true);
    }

    private get showFinancialFields(): boolean {
        return this.template === TemplateOptions.CZ;
    }
}
